import React from 'react';
import styles from './NoData.module.scss';
const ar = '/icons/noDataFound/ar.svg';
const en = '/icons/noDataFound/en.svg';

const NoData = ({ currentLanguage }) => {
  return (
    <div className={styles['no-data']}>
      {currentLanguage === 'en' ? (
        <img src={en} alt="" />
      ) : (
        <img src={ar} alt="" />
      )}
    </div>
  );
};

export default NoData;
